// PerformanceMetricsTable.js
import React from 'react';
import './PerformanceMetricsTable.css'; // Import the CSS file for styling

const PerformanceMetricsTable = ({ tableData }) => {
  console.log('PerformanceMetricsTable - tableData:', tableData); // Debugging

  return (
    <div className='performance-metrics-container'>
      <table className='table performance-metrics-table'>
        <thead>
          <tr>
            <th className='table-header'>Fund Name (Ticker)</th>
            <th className='table-header'># of Observations</th>
            <th className='table-header'>Outperform Benchmark</th>
            <th className='table-header'>% Outperform Benchmark</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='table-data'>{tableData.name}</td>
            <td className='table-data'>{tableData.numObservations}</td>
            <td className='table-data'>{tableData.outperform}</td>
            <td className='table-data'>{tableData.outperformPercent.toFixed(0)}%</td> {/* No decimals */}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PerformanceMetricsTable;
